import React, { useState, useEffect } from "react";
import { environment } from "../../environment";
import axios from "axios";
import { Form, Button, Dropdown } from "react-bootstrap";
import Select from "react-select";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Link, withRouter, useRouteMatch } from "react-router-dom";
import CsvDownload from "react-json-to-csv";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import NavbarNew from "../Components/NavbarNew";

const ViewUserResponse = ({ match }) => {
  const [answers, setAnsers] = useState([]);
  const [question, setQuestions] = useState([]);
  const [questionType, setQuestionType] = useState("");
  const [showButton, setShowButton] = useState(false);
  const [totalWaitage, setTotalWaitage] = useState(0);
  const [masterId, setMasterId] = useState(0);
  const [user_id, setUserId] = useState("");
  const [convertCsv, setConvertCsv] = useState(false);
  const [iaqData, setIaqData] = useState([]);
  const [username, setUserName] = useState("");
  const [key, setKey] = useState(1);
  const [showResponse, setShowResponse] = useState(true);
  const [showDownloadBtn, setShowDowbloadBtn] = useState(false);
  const [feedbackType, setFeedbackType] = useState("");

  let userId = match.params.userId;
  let master_id = Number(match.params.masterId);
  let answers_array = [];

  let master_dropdown = [];
  master_dropdown = [
    {
      questionMasterName: "Awareness",
      questionMasterId: 1,
    },
    {
      questionMasterName: "Current Usage Experience",
      questionMasterId: 2,
    },
    {
      questionMasterName: "Voluntary Questions",
      questionMasterId: 3,
    },
  ];
  useEffect(() => {
    setMasterId(master_id);
    setUserId(userId);
    if (key == 1) {
      setConvertCsv(true);
      axios
        .get(
          environment.dap_url +
            "questionnarieApi/getAllQuestionsWithAnswerAndWeightage/" +
            userId
        )
        .then((res) => {
          console.log(res.data.answers);

          console.log(res.data.totalResponseWaitage);
          setTotalWaitage(res.data.totalResponseWaitage);
          if (res.data.totalResponseWaitage > 0) {
            setConvertCsv(true);
          }
          setAnsers(res.data.answers);
          //totalResponseWaitage
          res.data.answers.forEach((element) => {
            setQuestions(element.question);
          });
          setShowButton(true);
          setShowResponse(true);

          res.data.answers.forEach((element, i) => {
            console.log(element.question);
            console.log(element?.answerDetails[0]?.response);
            answers_array.push({
              Sl_No: i + 1,
              Question: element.question,
              Weightage: element.waitage,
              Response: element?.answerDetails[0]?.response,
            });
          });
          setFeedbackType("Awareness");
          console.log(answers_array);
          setIaqData(answers_array);
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (key == 2) {
      setConvertCsv(true);
      axios
        .get(
          environment.dap_url +
            "questionnarieApi/getAllQuestionsWithAnswers/" +
            userId +
            "/2"
        )
        .then((res) => {
          console.log(res);
          setAnsers(res.data.notes);
          console.log(answers);
          setShowButton(true);
          setShowResponse(true);
          setTotalWaitage(res.data.totalResponseWaitage);
          if (res.data.notes) {
            res.data.notes.forEach((element, i) => {
              console.log(element.question);
              if (element?.answerDetails[0]?.response) {
                setShowDowbloadBtn(true);
              }

              answers_array.push({
                Sl_No: i + 1,
                Question: element.question,
                Weightage: element.waitage,
                Response: element?.answerDetails[0]?.response
                  ? element?.answerDetails[0]?.response
                  : JSON.stringify(element?.answerDetails[0]?.responseCheckBox),
              });
            });
            setFeedbackType("Current Usage Experience");
            console.log(answers_array);
            setIaqData(answers_array);
          }
        })
        .catch((err) => {
          console.log(err);
          setConvertCsv(false);
        });
    } else if (key == 3) {
      setConvertCsv(true);
      axios
        .get(
          environment.dap_url +
            "questionnarieApi/getAllQuestionsWithAnswers/" +
            userId +
            "/3"
        )
        .then((res) => {
          console.log(res);
          setAnsers(res.data.notes);
          setShowButton(true);
          setShowResponse(true);
          setTotalWaitage(res.data.totalResponseWaitage);
          if (res.data.notes) {
            res.data.notes.forEach((element, i) => {
              console.log(element.question);
              if (element?.answerDetails[0]?.response) {
                setShowDowbloadBtn(true);
              }

              answers_array.push({
                Sl_No: i + 1,
                Question: element.question,
                Weightage: element.waitage,
                Response: element?.answerDetails[0]?.response
                  ? element?.answerDetails[0]?.response
                  : JSON.stringify(element?.answerDetails[0]?.responseCheckBox),
              });
            });
            setFeedbackType("Voluntary Questions");
            console.log(answers_array);
            setIaqData(answers_array);
          }
        })
        .catch((err) => {
          console.log(err);
          setConvertCsv(false);
        });
    }
  }, [key]);
  const headers = [
    { label: "Sl No", key: "Sl No" },
    { label: "Question", key: "Question" },
    { label: "Weightage", key: "Weightage" },
    { label: "Response", key: "Response" },
  ];

  const csvReport = {
    data: iaqData,
    headers: headers,
    filename: username + "_" + feedbackType + ".csv",
  };

  return (
    <div className="container-fluid">
      <NavbarNew />
      <Link
        to="/user-feedback"
        className="btn btn-light my-3"
        style={{ marginLeft: 0 }}
      >
        Go Back
      </Link>

      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body"></div>
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => setKey(k)}
              className="mb-3"
            >
              <Tab eventKey={1} title="Awareness">
                <div style={{ marginLeft: "3%", marginTop: "2%" }}>
                  {masterId === 2 && showDownloadBtn ? (
                    <CsvDownload
                      className="btn btn-primary  add-group-btn"
                      {...csvReport}
                    >
                      {/* Export to CSV{" "} */}

                      <span>Download Response</span>
                    </CsvDownload>
                  ) : null}

                  {showResponse ? (
                    <>
                      {" "}
                      {masterId === 1 ? (
                        <>
                          <p style={{ margin: "2%" }}>
                            {" "}
                            <strong>Total Response Weightage:</strong>{" "}
                            {totalWaitage}{" "}
                          </p>
                          {convertCsv && (
                            <CsvDownload
                              className="btn btn-primary  add-group-btn"
                              {...csvReport}
                            >
                              {/* Export to CSV{" "} */}

                              <span>Download Response</span>
                            </CsvDownload>
                          )}
                        </>
                      ) : null}
                      {answers?.map((item, i) => (
                        <div style={{ margin: "2%" }}>
                          <div style={{ fontSize: "18px" }}>
                            <strong>Question {++i}:</strong>{" "}
                            <span key={item._id}>{item?.question}</span>
                          </div>
                          <div style={{ marginTop: "10px", fontSize: "18px" }}>
                            <strong>Ans:</strong>
                            <span key={item._id}>
                              {" "}
                              {item?.answerDetails[0]?.response || "Not Answered"}
                            </span>
                          </div>
                        </div>
                      ))}
                      {/* <Button style={{ marginLeft: "50%" }}>Fill User Response</Button> */}
                    </>
                  ) : null}

                  {showButton ? (
                    <Link
                      to={`/fill-user-response/${user_id}/1`}
                      className="btn btn-light my-3"
                    >
                      Fill User Response
                    </Link>
                  ) : null}
                </div>
              </Tab>

              <Tab
                eventKey={2}
                title="Current Usage Experience"
              >
                <div style={{ marginLeft: "3%", marginTop: "2%" }}>
                  {masterId === 2 && showDownloadBtn ? (
                    <CsvDownload
                      className="btn btn-primary  add-group-btn"
                      {...csvReport}
                    >
                      {/* Export to CSV{" "} */}

                      <span>Download Response</span>
                    </CsvDownload>
                  ) : null}

                  {showResponse ? (
                    <>
                      {" "}
                      {masterId === 1 ? (
                        <>
                          <p style={{ margin: "2%" }}>
                            {" "}
                            <strong>Total Response Weightage:</strong>{" "}
                            {totalWaitage}{" "}
                          </p>
                          {convertCsv && (
                            <CsvDownload
                              className="btn btn-primary  add-group-btn"
                              {...csvReport}
                            >
                              {/* Export to CSV{" "} */}

                              <span>Download Response</span>
                            </CsvDownload>
                          )}
                        </>
                      ) : null}
                      {answers?.map((item, i) => (
                        <div style={{ margin: "2%" }}>
                          <div style={{ fontSize: "18px" }}>
                            <strong>Question {++i}:</strong>{" "}
                            <span key={item._id}>{item?.question}</span>
                          </div>
                          <div style={{ marginTop: "10px", fontSize: "18px" }}>
                            <strong>Ans:</strong>{" "}

                            {item?.answerDetails && item.answerDetails.length > 0 ? (
                              item.answerDetails.map((res, index) => (
                                <React.Fragment key={index}>
                                  {res.responseCheckBox && res.responseCheckBox.length > 0 ? (
                                    res.responseCheckBox.map((option, idx) => (
                                      <span key={idx}> {option}, </span>
                                    ))
                                  ) : (
                                    <span>{res?.response || "Not Answered"}</span>
                                  )}
                                </React.Fragment>
                              ))
                            ) : (
                              <span>Not Answered</span>
                            )}
                          </div>
                        </div>
                      ))}
                      {/* <Button style={{ marginLeft: "50%" }}>Fill User Response</Button> */}
                    </>
                  ) : null}

                  {showButton ? (
                    <Link
                      to={`/fill-user-response/${user_id}/2`}
                      className="btn btn-light my-3"
                    >
                      Fill User Response
                    </Link>
                  ) : null}
                </div>
              </Tab>
              <Tab
                eventKey={3}
                title="Voluntary Questions"
              >
                <div style={{ marginLeft: "3%", marginTop: "2%" }}>
                  {masterId === 2 && showDownloadBtn ? (
                    <CsvDownload
                      className="btn btn-primary  add-group-btn"
                      {...csvReport}
                    >
                      {/* Export to CSV{" "} */}

                      <span>Download Response</span>
                    </CsvDownload>
                  ) : null}

                  {showResponse ? (
                    <>
                      {" "}
                      {masterId === 1 ? (
                        <>
                          <p style={{ margin: "2%" }}>
                            {" "}
                            <strong>Total Response Weightage:</strong>{" "}
                            {totalWaitage}{" "}
                          </p>
                          {convertCsv && (
                            <CsvDownload
                              className="btn btn-primary  add-group-btn"
                              {...csvReport}
                            >
                              {/* Export to CSV{" "} */}

                              <span>Download Response</span>
                            </CsvDownload>
                          )}
                        </>
                      ) : null}
                      {answers?.map((item, i) => (
                        <div style={{ margin: "2%" }}>
                          <div style={{ fontSize: "18px" }}>
                            <strong>Question {++i}:</strong>{" "}
                            <span key={item._id}>{item?.question}</span>
                          </div>
                          <div style={{ marginTop: "10px", fontSize: "18px" }}>
                            <strong>Ans:</strong>{" "}

                            {item?.answerDetails && item.answerDetails.length > 0 ? (
                              item.answerDetails.map((res, index) => (
                                <React.Fragment key={index}>
                                  {res.responseCheckBox && res.responseCheckBox.length > 0 ? (
                                    res.responseCheckBox.map((option, idx) => (
                                      <span key={idx}> {option}, </span>
                                    ))
                                  ) : (
                                    <span>{res?.response || "Not Answered"}</span>
                                  )}
                                </React.Fragment>
                              ))
                            ) : (
                              <span>Not Answered</span>
                            )}
                          </div>
                        </div>
                      ))}
                      {/* <Button style={{ marginLeft: "50%" }}>Fill User Response</Button> */}
                    </>
                  ) : null}

                  {showButton ? (
                    <Link
                      to={`/fill-user-response/${user_id}/3`}
                      className="btn btn-light my-3"
                    >
                      Fill User Response
                    </Link>
                  ) : null}
                </div>
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewUserResponse;
